/** UI ranges are always offsets in the literal cell, never in stretched glyphs. */
export type VerseWordAction = { start: number; end: number; boundary: number; label: string }

export function verseSplitActions(text: string, words: Array<{ text: string; splitBoundaryWordIndex: number | null }>): VerseWordAction[] | null {
  const tokens = Array.from(text.matchAll(/\S+/gu))
  // A stale or differently preprocessed context must retain the literal editor.
  if (tokens.length !== words.length || tokens.some((token, i) => token[0] !== words[i].text)) return null
  return tokens.flatMap((token, i) => words[i].splitBoundaryWordIndex === null ? [] : [{
    start: token.index!, end: token.index! + token[0].length,
    boundary: words[i].splitBoundaryWordIndex!, label: `Split after ${words[i].text}`,
  }])
}
